import { stripSensitiveFields } from 'utils/strip-sensitive-fields';
import React from 'react'
import Head from 'next/head'
import { Photos } from '../../../../components/profile/photos/Photos'
import { downloadAbout, getStringUserIdFromHandleName } from 'api/user/profile-api'

// This gets called on every request
export async function getServerSideProps({params}) {
  // Fetch data from external API
  const handleName = params.handleName
  const stringsUserId = (await getStringUserIdFromHandleName(handleName)).toString()
  const about = stripSensitiveFields(await downloadAbout("", stringsUserId))

  return {
    props: {
      handleName,
      stringsUserId,
      about
    },
  }
}

export default function Home(props) {
  const stringHandleName = props.handleName
  const stringsUserId = props.stringsUserId
  const about = props.about

  return (
    <>
      <Head>
        <title>{`${about.userFirstName} ${about.userLastName} Photos | StringsSG`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content={`Photos of ${about.userFirstName} ${about.userLastName} on StringsSG.`}/>
        <meta name="keywords" content={`Photos, ${about.userFirstName} ${about.userLastName}, StringsSG, House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner`}/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Photos of ${about.userFirstName} ${about.userLastName} | StringsSG`} />
        <meta property="og:description" content={`Photos of ${about.userFirstName} ${about.userLastName} on StringsSG.`} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content={`Photos of ${about.userFirstName} ${about.userLastName} | StringsSG`}/> 
        <meta name="twitter:description" content={`Photos of ${about.userFirstName} ${about.userLastName} on StringsSG.`}/>
        <link rel="canonical" href={`https://www.stringssg.com/profile/${stringHandleName}/photos`} />
        <link rel="icon" href="/favicon.ico" />
      </Head>   
        <div className="max-w-4xl mx-auto overflow-hidden"> 
            <Photos stringsUserId={stringsUserId} stringHandleName={stringHandleName}/>
        </div>
    </>
  )
}
